import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/site/Layout";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const [busy, setBusy] = useState(false);
  const { loginWithToken } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", form);
      loginWithToken(data.token, data.user);
      toast.success("Welcome. 5 credits granted.");
      nav("/models");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-24">
        <div className="overline mb-4">Members · New arrival</div>
        <h1 className="font-serif-editorial text-5xl tracking-tighter mb-4">Join the archive.</h1>
        <p className="text-neutral-500 mb-10 text-sm">Free tier includes 5 credits to try.</p>
        <form onSubmit={submit} className="space-y-5">
          <input value={form.name} onChange={e=>setForm({...form, name:e.target.value})} placeholder="Name (optional)"
            data-testid="signup-name"
            className="w-full bg-transparent border border-white/20 px-4 py-3 focus:border-white outline-none text-white placeholder:text-neutral-600"/>
          <input type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} placeholder="Email"
            required data-testid="signup-email"
            className="w-full bg-transparent border border-white/20 px-4 py-3 focus:border-white outline-none text-white placeholder:text-neutral-600"/>
          <input type="password" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} placeholder="Password (min 6)"
            required minLength={6} data-testid="signup-password"
            className="w-full bg-transparent border border-white/20 px-4 py-3 focus:border-white outline-none text-white placeholder:text-neutral-600"/>
          <button disabled={busy} type="submit" data-testid="signup-submit" className="btn-white w-full justify-center">
            {busy ? "..." : "Create account"}
          </button>
        </form>
        <div className="flex items-center gap-4 my-8">
          <div className="flex-1 h-px bg-white/10"/>
          <span className="text-xs text-neutral-500 font-mono-ui">OR</span>
          <div className="flex-1 h-px bg-white/10"/>
        </div>
        <button onClick={googleLogin} data-testid="signup-google" className="btn-ghost w-full justify-center">
          Continue with Google
        </button>
        <div className="text-sm text-neutral-500 mt-8 text-center">
          Have an account? <Link to="/login" className="text-white underline underline-offset-4">Sign in</Link>
        </div>
      </div>
    </Layout>
  );
}
